import { render, staticRenderFns } from "./CardViatic.vue?vue&type=template&id=38c6f88c&scoped=true"
import script from "./CardViatic.vue?vue&type=script&lang=js"
export * from "./CardViatic.vue?vue&type=script&lang=js"
import style0 from "./CardViatic.vue?vue&type=style&index=0&id=38c6f88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6f88c",
  null
  
)

export default component.exports